// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2M0QK","row":"ProcedureTreatmentSummary_row__1-tzK"};